export default "__VITE_ASSET__hw5YJIcu__";